import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useComparison } from "../../contexts/ComparisonContext";
import getProductImageUrl from "../../utils/imageUtils";
import styles from "../../styles/components/product/FloatingComparisonBar.module.css";
import { FaTimes } from "react-icons/fa";
import { comparisonTrayAllowed } from "../../utils/comparisonTray";

const COMPARISON_BAR_BODY_CLASS = "comparison-bar-open";

const FloatingComparisonBar = () => {
  const { selectedProducts, removeProduct, clearProducts } = useComparison();
  const navigate = useNavigate();
  const location = useLocation();

  const isVisible =
    comparisonTrayAllowed(location.pathname) && selectedProducts.length >= 2;

  useEffect(() => {
    document.body.classList.toggle(COMPARISON_BAR_BODY_CLASS, isVisible);
    return () => document.body.classList.remove(COMPARISON_BAR_BODY_CLASS);
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  const handleCompareNow = () => {
    // Keep selection in context/localStorage so refresh/back still works.
    navigate("/compare");
  };

  return (
    <div className={styles.floatingBar} role="region" aria-label="Comparison tray">
      <div className={styles.barContent}>
        <div className={styles.selectedInfo}>
          <span className={styles.count}>
            {selectedProducts.length} product
            {selectedProducts.length > 1 ? "s" : ""} selected
          </span>
          <div className={styles.thumbnails}>
            {selectedProducts.map((product) => (
              <div key={product._id} className={styles.thumbnail}>
                <img
                  src={getProductImageUrl(product.images?.[0])}
                  alt={product.name}
                  className={styles.thumbnailImage}
                />
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    removeProduct(product._id);
                  }}
                  title="Remove from comparison"
                  aria-label={`Remove ${product.name} from comparison`}
                >
                  <FaTimes size={10} />
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.clearBtn}
            onClick={clearProducts}
          >
            Clear All
          </button>
          <button
            type="button"
            className={styles.compareBtn}
            onClick={handleCompareNow}
          >
            Compare Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingComparisonBar;
